import { Paper, Stack, Typography, useTheme } from '@mui/material'
import { widgetStyles } from '../common/Widget'

const WidgetBase = (props) => {
  const { children, title, icon: Icon, hideHeader, status, header, isClickable } = props
  const theme = useTheme()
  const styles = widgetStyles(theme, status)

  const colorString = status || 'primary'

  let paperStyle = styles.basePaper
  if (isClickable) {
    paperStyle = { ...paperStyle, ...styles.basePaperClickable }
  }

  return (
    <Paper sx={paperStyle} elevation={0}>
      <div style={{ height: '100%', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        {hideHeader
          ? null
          : (
            <Stack direction='row' gap={1} alignItems='center' sx={{ width: '100%' }}>
              <Paper elevation={6} style={styles.logo}>
                <Icon style={{ margin: '10%', width: '85%', height: '85%' }} color={colorString} />
              </Paper>
              <Typography variant='h6'>{title}</Typography>
              {header}
            </Stack>
            )}
        <div style={{ flexGrow: 1, overflow: 'auto' }}> {children}</div>
      </div>
    </Paper>
  )
}

export default WidgetBase
